import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function ReglamentoPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Encabezado */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center overflow-hidden">
              <img
                src="https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/c966e299d7275505654852a65f959d1a.png"
                alt="Logo Baños Run"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-heading text-lg md:text-xl tracking-wide text-foreground-950">
              BAÑOS RUN 2026
            </span>
          </Link>
          <Link
            to="/"
            className="px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            ← Volver al inicio
          </Link>
        </div>
      </header>

      {/* Contenido del reglamento */}
      <main className="max-w-4xl mx-auto px-4 md:px-8 py-8 md:py-12">
        <article className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-10 text-foreground-800 leading-relaxed">
          {/* Título */}
          <header className="mb-8 border-b border-foreground-100 pb-6">
            <h1 className="font-heading text-3xl md:text-4xl text-primary-600 tracking-wide">
              BAÑOS RUN
            </h1>
            <p className="text-xl md:text-2xl text-foreground-700 mt-1">
              Campeonato Nacional de Carreras de Calle
            </p>
            <p className="text-lg text-foreground-600 mt-3 font-semibold">
              REGLAMENTO OFICIAL DE COMPETENCIA
            </p>
            <p className="text-sm text-foreground-500">
              BAÑOS RUN - CAMPEONATO NACIONAL DE CARRERAS DE CALLE 2026
            </p>
          </header>

          {/* 1 */}
          <section className="mb-8">
            <h2 className="font-heading text-2xl text-primary-600 mb-3">1. DISPOSICIONES GENERALES</h2>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">1.1. Organización y Aval Técnico</h3>
            <p className="mb-4">
              El "Baños Run - Campeonato Nacional de Carreras de Calle 2026" es un evento pedagógico y de
              alto rendimiento organizado de forma conjunta por el GAD Municipalidad de Baños de Agua Santa
              y la Federación Ecuatoriana de Atletismo (FEA). El evento cuenta con el aval internacional de
              World Athletics, garantizando que las distancias de 21 km, 5 km y 1 Milla se encuentran
              oficialmente homologadas y certificadas.
            </p>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">1.2. Datos de la Sede y Cronograma General</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Lugar: Baños de Agua Santa, Provincia de Tungurahua, Ecuador (Altitud: 1820 msnm; Temperatura promedio: 19 °C).</li>
              <li>Fecha del Evento: Sábado, 18 de julio de 2026.</li>
              <li>Punto de Salida y Llegada (Epicentro): Parque Montalvo de Baños.</li>
              <li>Hora de Inicio General: 07H00.</li>
            </ul>
          </section>

          {/* 2 */}
          <section className="mb-8">
            <h2 className="font-heading text-2xl text-primary-600 mb-3">2. CATEGORÍAS, DISTANCIAS Y EDADES</h2>
            <p className="mb-4">
              De conformidad con las regulaciones de la FEA y World Athletics, las categorías se estructuran
              estrictamente por año de nacimiento y edad cumplida:
            </p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border border-foreground-200">
                <thead>
                  <tr className="bg-foreground-50 text-left">
                    <th className="px-3 py-2 border border-foreground-200">Categoría</th>
                    <th className="px-3 py-2 border border-foreground-200">Año de Nacimiento</th>
                    <th className="px-3 py-2 border border-foreground-200">Edad Referencial</th>
                    <th className="px-3 py-2 border border-foreground-200">Distancias Habilitadas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-3 py-2 border border-foreground-200 font-semibold">Adultos</td>
                    <td className="px-3 py-2 border border-foreground-200">2006 en adelante</td>
                    <td className="px-3 py-2 border border-foreground-200">20 años cumplidos o más</td>
                    <td className="px-3 py-2 border border-foreground-200">21 km / 5 km / 1 Milla (Damas y Varones)</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2 border border-foreground-200 font-semibold">Juvenil U20</td>
                    <td className="px-3 py-2 border border-foreground-200">2007 y 2008</td>
                    <td className="px-3 py-2 border border-foreground-200">18 y 19 años</td>
                    <td className="px-3 py-2 border border-foreground-200">5 km / 1 Milla (Damas y Varones)</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2 border border-foreground-200 font-semibold">Prejuvenil U18</td>
                    <td className="px-3 py-2 border border-foreground-200">2009 y 2010</td>
                    <td className="px-3 py-2 border border-foreground-200">16 y 17 años</td>
                    <td className="px-3 py-2 border border-foreground-200">1 Milla (Damas y Varones)</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2 border border-foreground-200 font-semibold">Menores U16</td>
                    <td className="px-3 py-2 border border-foreground-200">2011, 2012 y 2013</td>
                    <td className="px-3 py-2 border border-foreground-200">13, 14 y 15 años</td>
                    <td className="px-3 py-2 border border-foreground-200">1 Milla (Damas y Varones)</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 3 */}
          <section className="mb-8">
            <h2 className="font-heading text-2xl text-primary-600 mb-3">
              3. PROGRAMA HORARIO OFICIAL DE LAS PRUEBAS (HORARIO DE LARGADAS)
            </h2>
            <p className="mb-4">
              El cumplimiento del horario es estricto. Los atletas deberán presentarse en la zona de llamado
              con 30 minutos de anticipación a su respectiva salida:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>07:00 – 21 km (Adultos: Damas y Varones)</li>
              <li>08:45 – 5 km (Adultos y U20: Damas)</li>
              <li>09:15 – 5 km (Adultos y U20: Varones)</li>
              <li>09:45 – 1 Milla (Adultos y U20: Damas)</li>
              <li>10:00 – 1 Milla (Adultos y U20: Varones)</li>
              <li>10:15 – 1 Milla (Prejuvenil U18: Damas)</li>
              <li>10:30 – 1 Milla (Prejuvenil U18: Varones)</li>
              <li>10:45 – 1 Milla (Menores U16: Damas)</li>
              <li>11:00 – 1 Milla (Menores U16: Varones)</li>
              <li>12:00 – Ceremonia Oficial de Premiación (Todas las categorías)</li>
            </ul>
          </section>

          {/* 4 */}
          <section className="mb-8">
            <h2 className="font-heading text-2xl text-primary-600 mb-3">
              4. PROCESO DE INSCRIPCIÓN Y COMPONENTES DEL KIT
            </h2>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">4.1. Inscripciones</h3>
            <ul className="list-disc pl-6 space-y-1 mb-4">
              <li>Plataforma Oficial: Las inscripciones se gestionarán exclusivamente en línea a través de la web oficial: www.banosrun.com.</li>
              <li>Fecha Límite: Hasta el miércoles 15 de julio de 2026 a las 20:00 horas. No se registrarán inscripciones extemporáneas.</li>
              <li>Soporte Técnico y Consultas: Lcdo. Néstor Quinapanta Vargas (Teléfono: 0979102532 / Correo electrónico: nestorquinapanta@gmail.com).</li>
            </ul>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">4.2. Costo y Derechos del Atleta</h3>
            <p className="mb-2">
              El valor de la inscripción es de $20.00 USD (Veinte Dólares Americanos) por atleta. Este pago
              otorga de forma irrenunciable los siguientes derechos:
            </p>
            <ul className="list-disc pl-6 space-y-1 mb-4">
              <li>Camiseta oficial conmemorativa del evento.</li>
              <li>Medalla de finalista al cruzar la meta de forma reglamentaria.</li>
              <li>Servicio de hidratación en ruta y zona de recuperación.</li>
              <li>Chip electrónico de cronometraje y dorsal de competencia.</li>
            </ul>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">4.3. Entrega de Chips y Dorsales (Kits de Competencia)</h3>
            <p className="mb-2">
              La entrega se efectuará en el Parque Montalvo de la ciudad de Baños (Av. Montalvo y 16 de
              Diciembre), en el siguiente horario:
            </p>
            <ul className="list-disc pl-6 space-y-1 mb-2">
              <li>Viernes 17 de julio de 2026: De 08h00 a 17h00.</li>
            </ul>
            <p className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-amber-900">
              Nota: Es mandatorio retirar el kit el día señalado (viernes 17 de julio). No se entregarán
              kits el día de la competencia (18 de julio).
            </p>
          </section>

          {/* 5 */}
          <section className="mb-8">
            <h2 className="font-heading text-2xl text-primary-600 mb-3">
              5. MANUAL TÉCNICO DE LOS RECORRIDOS Y SISTEMA VIAL
            </h2>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">5.1. Circuito Urbano Cerrado: Modalidades 21K y 5K</h3>
            <p className="mb-2">
              Consiste en un trazado técnico y cerrado que se ejecutará bajo la siguiente secuencia
              geométrica de circulación urbana:
            </p>
            <ol className="list-decimal pl-6 space-y-1 mb-4">
              <li>Partida y Vector de Salida: Despliegue desde el arco de salida ubicado en el Parque Montalvo, en la intersección de la Calle Juan Montalvo y Av. Eloy Alfaro, iniciando progresión lineal en sentido Oeste-Este.</li>
              <li>Tramo de Transición Oriental: Continuación por el eje de la Calle Juan Montalvo, cruzando el sector de las antiguas Termas de la Virgen, hasta interceptar la Calle Luis A. Martínez.</li>
              <li>Primer Quiebre y Eje Conectores: Avance por la Calle Luis A. Martínez hasta efectuar un giro controlado a la derecha para incorporarse de forma inmediata a la Calle Thomas Halflants, manteniendo el rumbo con dirección Norte de manera lineal.</li>
              <li>Vector de Retorno Occidental: Al arribar a la intersección con la Calle Oriente, se realiza un giro de 90 grados a la izquierda, avanzando en dirección Este-Oeste hasta conectar con la Calle Pastaza.</li>
              <li>Cierre y Reincorporación: Giro a la izquierda por la Calle Pastaza en sentido Norte-Sur para empalmar nuevamente con la Calle Juan Montalvo. Se prosigue en línea recta por esta vía hasta interceptar, tomar y continuar por la Calle Velasco Ibarra, completando así la geometría de la vuelta y el retorno al punto de origen.</li>
            </ol>
            <ul className="list-disc pl-6 space-y-1 mb-4">
              <li>Punto de Llegada (Meta Final): Parque Montalvo, en la intersección de la Calle Juan Montalvo y Calle 16 de Diciembre.</li>
            </ul>

            <p className="font-semibold text-foreground-900 mb-2">Matriz de Configuración por Distancia:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Modalidad 21K (Media Maratón): Los atletas deberán completar un total de 7 vueltas íntegras al circuito cerrado. El sistema de cronometraje electrónico validará el paso por la manta digital en cada giro. Al culminar la séptima vuelta, realizarán el desvío final hacia el embudo de meta.</li>
              <li>Modalidad 5K: Los atletas deberán completar un total de 2 vueltas íntegras al circuito cerrado. Al finalizar el segundo giro, ingresarán directamente al embudo de meta.</li>
            </ul>

            <h3 className="font-semibold text-lg text-foreground-900 mt-6 mb-2">5.2. Circuito Lineal: Modalidad Milla (1,609 Metros)</h3>
            <ul className="list-disc pl-6 space-y-1 mb-2">
              <li>Puntos de Control: Partida y Llegada en el Parque Montalvo (Intersección de las calles Juan Montalvo y Calle 16 de Diciembre).</li>
            </ul>
            <p className="font-semibold text-foreground-900 mb-1">Descripción del Trayecto:</p>
            <ol className="list-decimal pl-6 space-y-1 mb-4">
              <li>Inicio: Partida desde el arco técnico (Calle Juan Montalvo y Calle 16 de Diciembre) con dirección Oeste-Este.</li>
              <li>Tramo 1: Avance sostenido por la Calle Juan Montalvo, cruzando el sector de las antiguas Termas de la Virgen, hasta la intersección con la Calle Luis A. Martínez.</li>
              <li>Tramo 2: Continuación por la Calle Luis A. Martínez con dirección Norte hacia la Calle Pedro Vicente Maldonado.</li>
              <li>Tramo 3 (Retorno): Giro a la izquierda por la Calle Pedro Vicente Maldonado hasta conectar nuevamente con la Calle Juan Montalvo.</li>
              <li>Tramo Final: Incorporación a la Calle Juan Montalvo en dirección Este-Oeste, en línea recta y descendente hasta la intersección con la Calle 16 de Diciembre (Línea de Meta).</li>
            </ol>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">5.3. Seguridad Vial y Plan de Contingencia</h3>
            <p>
              Todo el circuito estará estrictamente cerrado al flujo vehicular motorizado durante el
              desarrollo del evento. Contará con señalización reflectiva de alta visibilidad, vallas de
              contención y conos de tráfico gestionados por el personal de seguridad y logística para
              salvaguardar la integridad de los atletas y jueces.
            </p>
          </section>

          {/* 6 */}
          <section className="mb-8">
            <h2 className="font-heading text-2xl text-primary-600 mb-3">
              6. CÓDIGO DE DISCIPLINA, DESCALIFICACIONES Y SANCIONES
            </h2>
            <p className="mb-4">
              El cuerpo de Jueces Oficiales y el Servicio Médico de la competencia están facultados para
              retirar y descalificar de forma inmediata a cualquier atleta que incurra en las siguientes
              faltas:
            </p>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">6.1. Tiempos Límite de Carrera (Tiempos de Corte)</h3>
            <p className="mb-2">
              Se establece un tiempo máximo de permanencia en el circuito. Todo atleta que supere estos
              límites será retirado de la prueba por su propia seguridad:
            </p>
            <ul className="list-disc pl-6 space-y-1 mb-4">
              <li>Distancia 21 km: Máximo 1 hora y 45 minutos (1h 45min).</li>
              <li>Distancia 5 km: Máximo 25 minutos (25min).</li>
              <li>Distancia 1 Milla: Máximo 10 minutos (10min).</li>
            </ul>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">6.2. Causas de Descalificación Automática</h3>
            <ul className="list-disc pl-6 space-y-1 mb-4">
              <li>No realizar la totalidad del recorrido a pie o salirse del trazado oficial marcado por la organización.</li>
              <li>No pasar por el control de salida, mantas digitales de cronometraje o puntos de control intermedios.</li>
              <li>No llevar el dorsal (número de competencia) fijado de forma visible en la parte delantera de la camiseta, o alterar/modificar el mismo.</li>
              <li>No portar el chip de cronometraje electrónico en el lugar y forma indicados por la organización.</li>
              <li>Recibir ayuda externa o avituallamiento fuera de las zonas técnicamente delimitadas.</li>
              <li>Competir acompañado de mascotas o personas ajenas a la competencia (especialmente menores de edad). Quienes infrinjan esto no figurarán en la clasificación oficial ni tendrán acceso a la premiación.</li>
              <li>No manifestar un comportamiento estrictamente deportivo o desacatar las indicaciones de jueces, cuerpo médico o personal de seguridad.</li>
            </ul>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">6.3. Sanciones Graves y Derecho de Admisión</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Suplantación de Identidad: En caso de detectarse fraude, suplantación de identidad, correr con el dorsal de otro competidor o usar un dorsal no autorizado, el infractor será penalizado con la sanción de 5 años sin poder inscribirse ni participar en esta competencia.</li>
              <li>Dopaje: Queda estrictamente prohibida la participación de cualquier atleta que se encuentre cumpliendo una sanción activa por dopaje dictada por el Comité Olímpico, la Federación Ecuatoriana de Atletismo o cualquier organismo internacional.</li>
              <li>Derecho de Admisión: El Comité Organizador se reserva formalmente el derecho de admisión de inscripciones de aquellos atletas que hayan calumniado, difamado, injuriado, insultado o mostrado conductas hostiles hacia los miembros de la organización a través de medios verbales, escritos o plataformas digitales.</li>
            </ul>
          </section>

          {/* 7 */}
          <section className="mb-8">
            <h2 className="font-heading text-2xl text-primary-600 mb-3">7. PREMIACIÓN Y CLASIFICACIONES</h2>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">7.1. Premiación Oficial</h3>
            <ul className="list-disc pl-6 space-y-1 mb-4">
              <li>Se otorgarán Medallas Oficiales de Oro, Plata y Bronce a los tres primeros lugares de cada una de las categorías y distancias estipuladas.</li>
              <li>Sorteos Especiales: Una vez concluido el evento, se sortearán premios e incentivos donados por los auspiciantes institucionales. Este sorteo se realizará única y exclusivamente entre los atletas inscritos que se encuentren presentes en el área del podio en ese instante.</li>
            </ul>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">7.2. Publicación de Resultados</h3>
            <p>
              La clasificación general oficial, avalada por el cuerpo de jueces, se publicará de manera
              digital en la página web oficial del evento: www.banosrun.com.
            </p>
          </section>

          {/* 8 */}
          <section>
            <h2 className="font-heading text-2xl text-primary-600 mb-3">
              8. RESPONSABILIDAD, EXONERACIÓN Y ACEPTACIÓN
            </h2>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">8.1. Declaración de Aptitud Física</h3>
            <p className="mb-4">
              Al momento de formalizar la inscripción, el atleta declara bajo juramento encontrarse en
              perfectas condiciones físicas, médicas y psicológicas para afrontar las exigencias de la
              carrera, asumiendo la competencia bajo su entera y exclusiva responsabilidad.
            </p>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">8.2. Deslindamiento de Responsabilidad</h3>
            <p className="mb-4">
              La organización declina toda responsabilidad civil o penal por los daños materiales, físicos o
              de cualquier otra índole que pudieran ocasionarse debido a imprudencias, negligencias o
              impericia de los atletas participantes. El seguro de asistencia del evento se activará única y
              exclusivamente tras la confirmación de la seriedad técnica del accidente por parte del servicio
              médico oficial en ruta.
            </p>

            <h3 className="font-semibold text-lg text-foreground-900 mb-2">8.3. Aceptación de los Términos</h3>
            <p>
              El acto normativo de inscripción implica la total e irrestricta aceptación del presente
              Reglamento General por parte del atleta. Cualquier situación técnica, logística o disciplinaria
              no prevista expresamente en este articulado será resuelta de manera inapelable por el Comité
              Organizador del Evento.
            </p>
          </section>
        </article>

        <div className="text-center mt-8">
          <Link
            to="/inscribirse"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-colors"
          >
            IR A INSCRIBIRME
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </main>
    </div>
  );
}
